import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { saveCampusSlugToCookie } from '../utils/campusFilter';
import { useCampusFilter } from '../context/CampusContext';

/**
 * Handles URLs like /allen, /dps, /vibgyor etc.
 *
 * Extracts the campus slug from the path, persists it in a cookie,
 * sets it in CampusContext, and redirects to the home/dashboard page.
 * The StudentDetails page will then use this slug to filter campuses
 * whose name includes the slug (case-insensitive).
 */
export const CampusSlugRedirect: React.FC = () => {
  const { campusSlug } = useParams<{ campusSlug: string }>();
  const navigate = useNavigate();
  const { setCampusSlug } = useCampusFilter();

  useEffect(() => {
    if (campusSlug) {
      const slug = campusSlug.toLowerCase().trim();
      saveCampusSlugToCookie(slug);
      setCampusSlug(slug);
    }
    // Redirect to home (dashboard for authenticated, login for unauthenticated)
    navigate('/', { replace: true });
  }, [campusSlug, navigate, setCampusSlug]);

  // Brief loading state while redirect happens
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div style={{ color: '#999', fontSize: '14px' }}>Redirecting...</div>
    </div>
  );
};
